export const AG_GRID_AUTO_COLUMN = 'ag-Grid-AutoColumn';
export const ROW_NUMBER_COLUMN_NAME = '#';
export const ROW_NUMBER_COLUMN_ID = 'A';
